import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ngx-custom-validators';
import { Location } from '@angular/common';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
import { UserHttpService } from 'src/app/http/user-http.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    styles: [],
})
export class UserEditComponent implements OnInit {
    constructor(
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        public location: Location,
        private userHttpService: UserHttpService,
        private router: Router,
        private modalService: NgbModal
    ) {}

    user: any;

    editUserForm = this.fb.group(
        {
            id: [null],
            firstName: [null, Validators.required],
            lastName: [null, Validators.required],
            userName: [null],
            email: [null, [CustomValidators.email, Validators.required]],
            roles: [null],
            branchId: [null, Validators.required],
            isEnabled: [true],
        },
        { updateOn: 'submit' }
    );

    formBusy: boolean;

    branches: any[] = [];

    isBranchRequired: boolean = true;

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.user = data.data[0];
            this.branches = data.data[1];
            this.patchForm(data.data[0]);
        });
    }

    patchForm(item: any) {
        this.editUserForm.patchValue(item);
        this.editUserForm.controls['roles'].setValue(item.roles[0]);

        if (item.roles[0] === 'branch') {
            this.isBranchRequired = true;
        } else {
            this.isBranchRequired = false;
        }
    }

    onSubmit() {
        this.editUserForm.markAsTouched();
        if (this.editUserForm.valid) {
            this.formBusy = true;
            this.editUserForm.value.roles = [this.editUserForm.value.roles];
            this.editUserForm.value.userName = this.editUserForm.value.email;
            this.userHttpService.editUser(this.editUserForm.value).subscribe(
                () => {
                    this.router.navigateByUrl('user-list', {
                        state: { hasState: true, type: 'success', message: 'User Updated successfully' },
                    });
                },
                () => {
                    this.formBusy = false;
                    this.editUserForm.setErrors({ exists: true });
                }
            );
        }
    }

    roleStateSub(ev: any) {
        if (ev.target.value === 'branch') {
            this.editUserForm.controls['branchId'].setValidators(Validators.required);
            this.editUserForm.controls['branchId'].updateValueAndValidity();
            this.isBranchRequired = true;
        } else if (ev.target.value === 'admin') {
            this.editUserForm.controls['branchId'].clearValidators();
            this.editUserForm.controls['branchId'].updateValueAndValidity();
            this.isBranchRequired = false;
        }
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this content item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.userHttpService.deleteUserById(item.id).subscribe(() => {
            this.router.navigateByUrl('user-list', {
                state: { hasState: true, type: 'success', message: 'User Deleted successfully' },
            });
        });
    }
}
